// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1fKCH","productName":"Table_productName__23OZJ"};